"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const extendTheme_1 = require("../extendTheme");
const lifeCycle_1 = require("../lifeCycle");
exports.theme = extendTheme_1.extendTheme(lifeCycle_1.theme, {
    name: 'schneider',
    userFriendlyName: 'Schneider',
    colors: {
        primary: '#333',
        primaryText: '#fff',
        primaryDark: '#3dcd57',
        danger: 'red',
        accent: '#42b4e6',
        accentBackgroundedText: '#fff',
        online: '#3dcd57',
    },
});
//# sourceMappingURL=index.js.map